export default "__VITE_ASSET__DFQWUNEQ__"